import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import logo from '../../assets/images/alrabie_logo.png';

const Banner = () => {
  const { t, i18n } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '10px',
        margin: '10px 0px',
        direction: i18n.language === 'ar' ? 'rtl' : 'ltr'
      }}
    >
      <img src={logo} alt='alrabie-logo' width='200' />
      <Typography
        variant='h4'
        component='h2'
        sx={{ 
          margin: '16px 0px', 
          fontWeight: '500',
          color: 'rgb(154,74,32)',
          // fontFamily: i18n.language === 'ar' ? 'Arial, sans-serif' : 'inherit'
        }}
      >
        {t('banner.companyName')}
      </Typography>
      <Typography 
        variant='p' 
        component='p'
        sx={{ 
          color: 'rgb(154,74,32)',
          fontWeight: '500',
          // fontFamily: i18n.language === 'ar' ? 'Arial, sans-serif' : 'inherit',
          textAlign: 'center'
        }}
      >
        {t('banner.slogan')}
      </Typography>
      <Typography 
        variant='i' 
        component='i'
        sx={{ 
          color: '#7f5e1f',
          fontWeight: '400',
          textAlign: 'center'
        }}
      >
        "{t('banner.subSlogan')}"
      </Typography>
    </Box>
  );
};

export default Banner;
